import React, { useContext, useEffect, useState } from "react";
import Loader from "../../components/Loader/Loader";
import { FcInfo } from "react-icons/fc";
import { CheckListContext } from "../../utils/checkListContext";
import "semantic-ui-css/semantic.min.css";
import Swal from "sweetalert2";
import QuestionSection from "../../components/questionSection";
import { useNavigate } from "react-router-dom";
import Form from "../../components/form";

export default function AdminNewCheckQuestions({
  tableName,
  status,
  answeredData,
  product_id,
  userid,
  lang,
}) {
  const [preAnswerData, setPreAnswerData] = useState({});
  const [def, setDef] = useState({});
  let navigate = useNavigate();
  const {
    tempJSON,
    setTempJSON,
    setTotalQuestions,
    loadCheck,
    setLoadCheck,
    errors,
    ratingMetadata,
    setRatingMetadata,
    checklistData,
  } = useContext(CheckListContext);


  useEffect(() => {
    let totalNo = checklistData
      ? checklistData.filter((item) => item.cat === tableName)?.length
      : "";
    setTotalQuestions((prev) => ({ ...prev, [tableName]: totalNo }));
  }, [tableName, checklistData]);

  useEffect(() => {
    let responseData = "";
    let responseRating = "";
    if (
      answeredData?.data?.id == product_id
    ) {
      responseData = answeredData?.data?.checklist;
      responseRating = answeredData?.data?.rating_metadata;
    }

    setPreAnswerData(responseData);
    let preAnswer = tempJSON;
    let ratingdata = ratingMetadata;
    Object.keys(responseData)?.map((item) => {
      preAnswer = { ...preAnswer, [item]: responseData[item] };
      ratingdata = { ...ratingdata, [item]: responseRating?.[item] };
      setLoadCheck(false);
      return preAnswer;
    });
    if (loadCheck) {
      setRatingMetadata(ratingdata);
      setTempJSON(preAnswer);
    }
  }, []);

  const handleChange = (e, response, item) => {

    if(!answeredData?.data?.review_status){

      const { name, value, type } = e.target;
      let rating_metadataVar = ratingMetadata;
      let tempJSONVar = tempJSON;
      let rangeObj = item["range"];
      let resultvar = "";
      if (!status) {
        if (
          tempJSON.hasOwnProperty(item["id"]) &&
          tempJSON[item["id"]] !== response
        ) {
          Swal.fire({
            html: "Are you sure want to modify?<br/>" + "it will affect rating.",
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: "Cancel",
            confirmButtonColor: "#652078",
            confirmButtonText: "Yes",
            reverseButtons: true,
          }).then((result) => {
            if (result.dismiss === Swal.DismissReason.cancel) {
              resultvar = tempJSON[item["id"]];
            } else if (result.isConfirmed) {
              resultvar = response;
              setTempJSON((prev) => ({
                ...prev,
                [item["id"]]: resultvar,
              }));
            }
          });
        } else if (item["input_type"] === 4 && !status) {
          rangeObj =
            rangeObj !== "-" && rangeObj !== "" && rangeObj
              ? JSON.parse(rangeObj)
              : undefined;
          if (rangeObj && rating_metadataVar[item["id"]] !== "") {
            let toggleAnswer = "";
            if (
              rangeObj["ov_max"] !== rangeObj["ov_min"] &&
              rating_metadataVar[item["id"]] >= rangeObj["ov_min"] &&
              rating_metadataVar[item["id"]] <= rangeObj["ov_max"]
            ) {
              toggleAnswer = response;
            } else if (
              rangeObj["ov_max"] !== rangeObj["ov_min"] &&
              rating_metadataVar[item["id"]] >= rangeObj["min"] &&
              rating_metadataVar[item["id"]] < rangeObj["ov_min"]
            ) {
              toggleAnswer = "not_ok";
            } else if (
              rangeObj["ov_max"] !== rangeObj["ov_min"] &&
              rating_metadataVar[item["id"]] > rangeObj["ov_max"] &&
              rating_metadataVar[item["id"]] <= rangeObj["max"]
            ) {
              toggleAnswer = "ok";
            } else if (
              rangeObj["ov_max"] === rangeObj["ov_min"] &&
              rating_metadataVar[item["id"]] >= rangeObj["min"] &&
              rating_metadataVar[item["id"]] < rangeObj["ov_min"]
            ) {
              toggleAnswer = "not_ok";
            } else if (
              rangeObj["ov_max"] === rangeObj["ov_min"] &&
              rating_metadataVar[item["id"]] >= rangeObj["ov_max"] &&
              rating_metadataVar[item["id"]] <= rangeObj["max"]
            ) {
              toggleAnswer = "ok";
            }
  
            tempJSONVar = { ...tempJSONVar, [item["id"]]: toggleAnswer };
            setTempJSON(tempJSONVar);
            setRatingMetadata(rating_metadataVar);
            setDef((defItem) => ({
              ...defItem,
              rating_metadata: rating_metadataVar,
            }));
          } else if (response !== "" || value === "") {
            tempJSONVar = { ...tempJSONVar, [item["id"]]: value };
            setTempJSON(tempJSONVar);
            rating_metadataVar = { ...rating_metadataVar, [item["id"]]: value };
            setRatingMetadata(rating_metadataVar);
            setDef((defItem) => ({
              ...defItem,
              rating_metadata: rating_metadataVar,
            }));
          }
        } else if (!status && response !== "") {
          tempJSONVar = { ...tempJSONVar, [item["id"]]: response };
          setTempJSON(tempJSONVar);
        }
      }
    }

  };

  const toast = (e, message) => {
    Swal.fire({
      html: `<div style={{text-align:"center"}}>${message}</div>`,
      customClass: {
        container: "position-absolute",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
      confirmButtonColor: "#652078",
      toast: true,
      confirmButtonText: "Close",
      position: "bottom-center",
    });
  };

  let Sr_No = 0;
  return (
    <div style={{ margin: "16px 0" }}>
      {!checklistData ? (
        <Loader />
      ) : (
        checklistData?.map((item, index) => {
          let rangeObj = "";
          rangeObj =
            item["range"] !== "-" ? JSON.parse(item["range"]) : undefined;
          return (
            item.visibility &&
            item["id"] &&
            item["q"] &&
            item["q"] !== "" &&
            item["id"] !== "" &&
            item["cat"]?.toLowerCase() === tableName?.toLowerCase() && (
              <QuestionSection key={index}>
                <QuestionSection.QuestionTextContainer>
                  <QuestionSection.QuestionLabelContainer>
                    <QuestionSection.QuestionLabel>
                      Q{(Sr_No = Sr_No + 1)}
                    </QuestionSection.QuestionLabel>
                  </QuestionSection.QuestionLabelContainer>
                  <QuestionSection.Question>
                    {item[`q`]}
                  </QuestionSection.Question>
                  <QuestionSection.InfoIconContainer>
                    <FcInfo
                      style={{ float: "right", width: "20px", height: "20px" }}
                      onClick={(e) => toast(e, item[`guideline`])}
                    />
                  </QuestionSection.InfoIconContainer>
                </QuestionSection.QuestionTextContainer>
                {item.input_type === 4 ? (
                  <>
                    <QuestionSection.MainContainer>
                      <Form.Input
                        type="number"
                        name={`${tableName}_${index}`}
                        id={`${tableName}_${index}`}
                        onChange={(e) => handleChange(e, "", item)}
                        value={ratingMetadata?.[item["id"]]}
                        disabled
                      />
                    </QuestionSection.MainContainer>
                    {rangeObj && (
                      <>
                        {rangeObj["ov_max"] !== rangeObj["ov_min"] &&
                        ratingMetadata?.[item["id"]] >= rangeObj["ov_min"] &&
                        ratingMetadata?.[item["id"]] <= rangeObj["ov_max"] ? (
                          <QuestionSection.MainContainer>
                            <QuestionSection.AnswerContainer>
                              {tempJSON[item["id"]] === "not_ok" ? (
                                <QuestionSection.AnswerIconContainer
                                  onClick={(e) =>
                                    handleChange(e, "not_ok", item)
                                  }
                                  styleAttributes={{
                                    backgroundColor: "#FF5471",
                                    color: "#FFFF",
                                    borderColor: "#FF5471",
                                  }}
                                >
                                  <QuestionSection.AnswerIcon src="../assets/answer/thumpsDown.svg" />
                                  <QuestionSection.Answer>
                                    NOT OK
                                  </QuestionSection.Answer>
                                </QuestionSection.AnswerIconContainer>
                              ) : (
                                <QuestionSection.AnswerIconContainer
                                  onClick={(e) =>
                                    handleChange(e, "not_ok", item)
                                  }
                                  styleAttributes={{ borderColor: "#FF5471" }}
                                >
                                  <QuestionSection.AnswerIcon src="../assets/answer/thumpsDown.svg" />
                                  <QuestionSection.Answer>
                                    NOT OK
                                  </QuestionSection.Answer>
                                </QuestionSection.AnswerIconContainer>
                              )}
                              {tempJSON[item["id"]] === "ok" ? (
                                <QuestionSection.AnswerIconContainer
                                  onClick={(e) => handleChange(e, "ok", item)}
                                  styleAttributes={{
                                    backgroundColor: "#3BE656",
                                    color: "#FFFF",
                                    borderColor: "#3BE656",
                                  }}
                                >
                                  <QuestionSection.AnswerIcon src="../assets/answer/thumpsUp.svg" />
                                  <QuestionSection.Answer>
                                    ALL OK
                                  </QuestionSection.Answer>
                                </QuestionSection.AnswerIconContainer>
                              ) : (
                                <QuestionSection.AnswerIconContainer
                                  onClick={(e) => handleChange(e, "ok", item)}
                                  styleAttributes={{ borderColor: "#3BE656" }}
                                >
                                  <QuestionSection.AnswerIcon src="../assets/answer/thumpsUp.svg" />
                                  <QuestionSection.Answer>
                                    ALL OK
                                  </QuestionSection.Answer>
                                </QuestionSection.AnswerIconContainer>
                              )}
                            </QuestionSection.AnswerContainer>
                          </QuestionSection.MainContainer>
                        ) : rangeObj["ov_max"] !== rangeObj["ov_min"] &&
                          ratingMetadata[[item["id"]]] !== "" &&
                          ((ratingMetadata?.[item["id"]] >= rangeObj["min"] &&
                            ratingMetadata?.[item["id"]] <
                              rangeObj["ov_min"]) ||
                            (ratingMetadata?.[item["id"]] >
                              rangeObj["ov_max"] &&
                              ratingMetadata?.[item["id"]] <=
                                rangeObj["max"])) ? (
                          <QuestionSection.MainContainer>
                            <QuestionSection.AnswerContainer>
                              {tempJSON[item["id"]] === "not_ok" ? (
                                <QuestionSection.AnswerIconContainer
                                  onClick={(e) =>
                                    handleChange(e, "not_ok", item)
                                  }
                                  styleAttributes={{
                                    backgroundColor: "#FF5471",
                                    color: "#FFFF",
                                    borderColor: "#FF5471",
                                  }}
                                  disabled
                                >
                                  <QuestionSection.AnswerIcon src="../assets/answer/thumpsDown.svg" />
                                  <QuestionSection.Answer>
                                    NOT OK
                                  </QuestionSection.Answer>
                                </QuestionSection.AnswerIconContainer>
                              ) : (
                                <QuestionSection.AnswerIconContainer
                                  onClick={(e) =>
                                    handleChange(e, "not_ok", item)
                                  }
                                  styleAttributes={{ borderColor: "#FF5471" }}
                                  disabled
                                >
                                  <QuestionSection.AnswerIcon src="../assets/answer/thumpsDown.svg" />
                                  <QuestionSection.Answer>
                                    NOT OK
                                  </QuestionSection.Answer>
                                </QuestionSection.AnswerIconContainer>
                              )}
                              {tempJSON[item["id"]] === "ok" ? (
                                <QuestionSection.AnswerIconContainer
                                  onClick={(e) => handleChange(e, "ok", item)}
                                  styleAttributes={{
                                    backgroundColor: "#3BE656",
                                    color: "#FFFF",
                                    borderColor: "#3BE656",
                                  }}
                                  disabled
                                >
                                  <QuestionSection.AnswerIcon src="../assets/answer/thumpsUp.svg" />
                                  <QuestionSection.Answer>
                                    ALL OK
                                  </QuestionSection.Answer>
                                </QuestionSection.AnswerIconContainer>
                              ) : (
                                <QuestionSection.AnswerIconContainer
                                  onClick={(e) => handleChange(e, "ok", item)}
                                  styleAttributes={{ borderColor: "#3BE656" }}
                                  disabled
                                >
                                  <QuestionSection.AnswerIcon src="../assets/answer/thumpsUp.svg" />
                                  <QuestionSection.Answer>
                                    ALL OK
                                  </QuestionSection.Answer>
                                </QuestionSection.AnswerIconContainer>
                              )}
                            </QuestionSection.AnswerContainer>
                          </QuestionSection.MainContainer>
                        ) : (
                          ""
                        )}
                      </>
                    )}
                    {rangeObj && (
                      <>
                        {rangeObj["ov_max"] === rangeObj["ov_min"] &&
                          ratingMetadata[[item["id"]]] !== "" &&
                          ((ratingMetadata?.[item["id"]] >= rangeObj["min"] &&
                            ratingMetadata?.[item["id"]] <
                              rangeObj["ov_min"]) ||
                            (ratingMetadata?.[item["id"]] >=
                              rangeObj["ov_max"] &&
                              ratingMetadata?.[item["id"]] <=
                                rangeObj["max"])) && (
                            <QuestionSection.MainContainer>
                              <QuestionSection.AnswerContainer>
                                {tempJSON[item["id"]] === "not_ok" ? (
                                  <QuestionSection.AnswerIconContainer
                                    onClick={(e) =>
                                      handleChange(e, "not_ok", item)
                                    }
                                    styleAttributes={{
                                      backgroundColor: "#FF5471",
                                      color: "#FFFF",
                                      borderColor: "#FF5471",
                                    }}
                                    disabled
                                  >
                                    <QuestionSection.AnswerIcon src="../assets/answer/thumpsDown.svg" />
                                    <QuestionSection.Answer>
                                      NOT OK
                                    </QuestionSection.Answer>
                                  </QuestionSection.AnswerIconContainer>
                                ) : (
                                  <QuestionSection.AnswerIconContainer
                                    onClick={(e) =>
                                      handleChange(e, "not_ok", item)
                                    }
                                    styleAttributes={{ borderColor: "#FF5471" }}
                                    disabled
                                  >
                                    <QuestionSection.AnswerIcon src="../assets/answer/thumpsDown.svg" />
                                    <QuestionSection.Answer>
                                      NOT OK
                                    </QuestionSection.Answer>
                                  </QuestionSection.AnswerIconContainer>
                                )}
                                {tempJSON[item["id"]] === "ok" ? (
                                  <QuestionSection.AnswerIconContainer
                                    onClick={(e) => handleChange(e, "ok", item)}
                                    styleAttributes={{
                                      backgroundColor: "#3BE656",
                                      color: "#FFFF",
                                      borderColor: "#3BE656",
                                    }}
                                    disabled
                                  >
                                    <QuestionSection.AnswerIcon src="../assets/answer/thumpsUp.svg" />
                                    <QuestionSection.Answer>
                                      ALL OK
                                    </QuestionSection.Answer>
                                  </QuestionSection.AnswerIconContainer>
                                ) : (
                                  <QuestionSection.AnswerIconContainer
                                    onClick={(e) => handleChange(e, "ok", item)}
                                    styleAttributes={{ borderColor: "#3BE656" }}
                                    disabled
                                  >
                                    <QuestionSection.AnswerIcon src="../assets/answer/thumpsUp.svg" />
                                    <QuestionSection.Answer>
                                      ALL OK
                                    </QuestionSection.Answer>
                                  </QuestionSection.AnswerIconContainer>
                                )}
                              </QuestionSection.AnswerContainer>
                            </QuestionSection.MainContainer>
                          )}
                      </>
                    )}
                  </>
                ) : (
                  <QuestionSection.MainContainer>
                    <QuestionSection.AnswerContainer>
                      {tempJSON[item["id"]] === "not_ok" ? (
                        <QuestionSection.AnswerIconContainer
                          onClick={(e) => handleChange(e, "not_ok", item)}
                          styleAttributes={{
                            backgroundColor: "#FF5471",
                            color: "#FFFF",
                            borderColor: "#FF5471",
                          }}
                        >
                          <QuestionSection.AnswerIcon src="../assets/answer/thumpsDown.svg" />
                          <QuestionSection.Answer>
                            NOT OK
                          </QuestionSection.Answer>
                        </QuestionSection.AnswerIconContainer>
                      ) : (
                        <QuestionSection.AnswerIconContainer
                          onClick={(e) => handleChange(e, "not_ok", item)}
                          styleAttributes={{ borderColor: "#FF5471" }}
                        >
                          <QuestionSection.AnswerIcon src="../assets/answer/thumpsDown.svg" />
                          <QuestionSection.Answer>
                            NOT OK
                          </QuestionSection.Answer>
                        </QuestionSection.AnswerIconContainer>
                      )}

                      {tempJSON[item["id"]] === "ok" ? (
                        <QuestionSection.AnswerIconContainer
                          onClick={(e) => handleChange(e, "ok", item)}
                          styleAttributes={{
                            backgroundColor: "#3BE656",
                            color: "#FFFF",
                            borderColor: "#3BE656",
                          }}
                        >
                          <QuestionSection.AnswerIcon src="../assets/answer/thumpsUp.svg" />
                          <QuestionSection.Answer>
                            ALL OK
                          </QuestionSection.Answer>
                        </QuestionSection.AnswerIconContainer>
                      ) : (
                        <QuestionSection.AnswerIconContainer
                          onClick={(e) => handleChange(e, "ok", item)}
                          styleAttributes={{ borderColor: "#3BE656" }}
                        >
                          <QuestionSection.AnswerIcon src="../assets/answer/thumpsUp.svg" />
                          <QuestionSection.Answer>
                            ALL OK
                          </QuestionSection.Answer>
                        </QuestionSection.AnswerIconContainer>
                      )}
                    </QuestionSection.AnswerContainer>
                  </QuestionSection.MainContainer>
                )}
                <div style={{ marginBottom: "10px" }}></div>
                {errors?.hasOwnProperty(`${item["id"]}`) && (
                  <h5 style={{ color: "red", marginTop: "2px" }}>
                    {errors[`${item["id"]}`]}
                  </h5>
                )}
              </QuestionSection>
            )
          );
        })
      )}
    </div>
  );
}